import { Component } from 'preact'
import WidgetPreview from '../components/widget-preview';
import {
    LayoutFilter,
    BackgroundFilter,
    LinkFilter,
    ReviewItemFrameFilter,
    OuterWrapperFrameFilter
} from '../components/filters';
import { __ } from '../../locales'

class WfHorizontal extends Component {
    state = {
        selectedLayout: 'layoutXL',
        layoutOptions: [
            {
                label: 'Horizontal Layout XL',
                value: 'layoutXL'
            },
            {
                label: 'Horizontal Layout L',
                value: 'layoutL'
            },
            {
                label: 'Horizontal Layout M',
                value: 'layoutM'
            },
            {
                label: 'Horizontal Layout S',
                value: 'layoutS'
            },
            {
                label: 'Horizontal Layout XS',
                value: 'layoutXS'
            },
            {
                label: 'Horizontal Layout A',
                value: 'layoutA'
            },
        ]
    };

    render(props, state) {
        return (
            <WidgetPreview
                {...props}
                name={__('widget.trust_score_banner.name')}
                description={__('widget.trust_score_banner.description')}
                bestFor={[__('global.homepage'),  __('global.footer'), __('global.header')]}
                type={'horizontal-widget'}
                extraParams={[
                    'slugs',
                    'outerFrame',
                    'background',
                    'linkUrl',
                ]}
                layoutType={state.selectedLayout}
                badgeTitle={__('widget.type.banner')}
                badgeColor={'#FFC1BE'}
            >
                <div className={'filters-wrapper mt-5 mb-5'}>
                    <LinkFilter
                        {...props}
                        hidden={props.inputs?.profileType === 'specialist' && props.selectedProfiles?.length <= 1}
                    />
                    <LayoutFilter
                        selectedLayout={state.selectedLayout}
                        options={state.layoutOptions}
                        onChange={ev => this.setState({ selectedLayout: ev.target.value })}
                    />
                    <BackgroundFilter {...props} />
                    <ReviewItemFrameFilter {...props} />
                    <OuterWrapperFrameFilter {...props} />
                </div>
            </WidgetPreview>
        );
    }
}

export default WfHorizontal
